import React, { useEffect, useState } from 'react';
import UnitDetailsBanner from '../../components/unitDetails/unitDetailsBanner'
import Header from "../../shared/header"
import PagesFooter from "../../shared/pagesFooter"
import UnitDetailsSpecification from '../../components/unitDetails/unitDetailsSpecification'
import UnitDetailsPlans from '../../components/unitDetails/unitDetailsPlans'
import Disclaimer from '../../components/unitDetails/disclaimer'
import axios from 'axios';
import { useParams } from 'react-router-dom';

const UnitDetailsPage = () => {
  const [selectedType, setSelectedType] = useState("Designer Suite");
  const [data, setData] = useState(null);
    const [paymentPlans, setPaymentPlans] = useState(null);
    const { floor, unitNumber } = useParams();
    console.log('UnitLayOut', floor, unitNumber);
    useEffect(() => {
      // Fetch data from the API
      const fetchData = async () => {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}property/aggregateProperties`, {
            floor,
            unitNumber
          });
          console.log('response', response);
          setData(response.data.body);
          getPaymentPlans(response.data.body[0]._id)
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      };

      fetchData();
    }, [floor, unitNumber]);

    const getPaymentPlans = async (propertyId) => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}property/getPackages?propertyId=${propertyId}`, {
        });
        console.log('getPaymentPlans', response);
        setPaymentPlans(response.data.body);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    if (!data) {
      return <div>Loading...</div>;
    }


  return (
    <div>
      <div className='unit-details-header'>
        <Header />
      </div>
      <UnitDetailsBanner data={data} />
       <UnitDetailsSpecification data={data} selectedType={selectedType} />
      <UnitDetailsPlans plans={paymentPlans} />
     <Disclaimer data={data} />
      <PagesFooter />
    </div>
  )
}

export default UnitDetailsPage
